import lightTheme from './schemas/light';
import darkTheme from './schemas/dark';

export { lightTheme, darkTheme };

export { breakpoint } from './schemas/breakpoint';
